import React from "react";
import {
  Button,
  IconButton,
  TextField,
  Select,
  MenuItem,
  Box,
  FormHelperText,
} from "@mui/material";
import { Delete as DeleteIcon } from "@mui/icons-material";

const PetDetailsField = ({
  formData = [],
  onChange,
  errorSchema = {},
  rawErrors = [],
}) => {
  const handleAddPet = () => {
    const newPet = { petType: "", petWeight: "", size: "Medium" };
    onChange([...formData, newPet]);
  };

  const handleRemovePet = (index) => {
    const newData = formData.filter((_, i) => i !== index);
    onChange(newData);
  };

  const handleFieldChange = (index, field, value) => {
    const updated = [...formData];
    updated[index] = { ...updated[index], [field]: value };
    onChange(updated);
  };

  return (
    <>
      {formData.map((pet, index) => (
        <Box
          key={index}
          mb={2}
          display="flex"
          alignItems="center"
          flexWrap={{xs:"wrap", md: "nowrap"}}
          gap={2}
        >
          {/* Pet Type */}
          <TextField
            label="Pet Type"
            value={pet.petType || ""}
            onChange={(e) =>
              handleFieldChange(index, "petType", e.target.value)
            }
            fullWidth
            error={!!errorSchema?.[index]?.petType?.__errors?.length}
            helperText={errorSchema?.[index]?.petType?.__errors?.[0]}
          />

          {/* Pet Weight as string */}
          <TextField
            label="Weight (lbs)"
            type="text"
            inputProps={{
              inputMode: "decimal",
              pattern: "[0-9]*[.]?[0-9]{0,2}",
            }}
            value={pet.petWeight ?? ""}
            onChange={(e) => handleFieldChange(index, "petWeight", e.target.value)}
            fullWidth
            error={!!errorSchema?.[index]?.petWeight?.__errors?.length}
            helperText={errorSchema?.[index]?.petWeight?.__errors?.[0]}
          />

          {/* Size Dropdown */}
          <Select
            value={pet.size || "Medium"}
            onChange={(e) => handleFieldChange(index, "size", e.target.value)}
            fullWidth
          >
            <MenuItem value="Small">Small</MenuItem>
            <MenuItem value="Medium">Medium</MenuItem>
            <MenuItem value="Large">Large</MenuItem>
          </Select>

          {/* Delete Pet */}
          <IconButton
            onClick={() => handleRemovePet(index)}
            color="error"
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}

      {/* Array-level error */}
      {Array.isArray(rawErrors) && rawErrors.length > 0 && (
        <FormHelperText error>{rawErrors[0]}</FormHelperText>
      )}
      <Button sx={{ml: "auto"}} variant="contained" onClick={handleAddPet}>
        Add Pet
      </Button>
    </>
  );
};

export default PetDetailsField;
